import ManageAcuiteVisuelle from '@/views/consultations/en-cours/ophtalmologie/acuite-visuelle/manage-acuite-visuelle'
import $ from 'jquery'
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'acuite-visuelle',
    components: {
        ManageAcuiteVisuelle
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            info_user: {},
            grs_toggler: 0,
            group_id: 0,
            list_acuites: [],
            selected_acuite: [],
            data_to_be_deleted: {},
        }
    },

    watch: {
        evolution_toggler() {
            this.getData()
        }
    },

    computed: {

    },


    mounted() {
        this.userInfoSetter()
        this.getData()
    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        getData() {
            this.is_loading = true
            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                data_type: 'acuite_visuelle',
                est_en_cours: true
            }

            return store_fiche.getCustomConsultationSectionData(data).then((response) => {
                this.list_acuites = response
                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                
            }).catch(() => {
                this.is_empty = true
            }).finally(() => {
                this.is_loading = false
            })
        },

        addNew() {
            this.group_id = 0
            this.selected_acuite = []
            
            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#acv-'+this.evolution_id).modal('show')
        },

        editAcuite(data) {
            this.group_id = data.group_service_id
            this.selected_acuite = data.fields

            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#acv-'+this.evolution_id).modal('show')
        },

        removeAcuite(data) {
            this.data_to_be_deleted = {
                libelle: data.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: data.group_service_id,
                data_type: 'acuite_visuelle'
            }

            $('.del-grp-acv'+this.evolution_id).modal('show')
        }
    }
}
